import React from 'react';
import { Panel, StatefulPanel, StatefulPanelProps } from 'baseui/accordion';
import { IDummyProps } from './types';
import { contentStyles } from './styles';
import { styled, useStyletron } from '../../Themes';
import { PanelOverrides } from './overrides';
import { mergeOverrides } from 'baseui';

export const StatefulViewPanel = (props: IDummyProps & StatefulPanelProps) => {
	const [css, theme] = useStyletron();
	const { overrides, ...rest } = props;

	return (
		<StatefulPanel
			{...rest}
			overrides={overrides ? mergeOverrides(PanelOverrides(props), overrides as any) : PanelOverrides(props)}
		>
			<div className={css(contentStyles(props, theme))}>{props.children}</div>
		</StatefulPanel>
	);
};
export const ViewPanel = React.forwardRef((props: IDummyProps, ref: any) => {
	const [css, theme] = useStyletron();
	const { rootref, overrides, ...rest } = props;

	return (
		<Panel
			ref={ref}
			{...rest}
			overrides={overrides ? mergeOverrides(PanelOverrides(props), overrides as any) : PanelOverrides(props)}
		>
			<div className={css(contentStyles(props, theme))}>{props.children}</div>
		</Panel>
	);
});

export const PanelFooter = styled('div', ({ $theme }: any) => {
	return {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginTop: 'var(--epods--space-inset-m)',
		width: '100%',
	};
});
